import {
    Message
} from "element-ui";
import {
    getInfo,
    editMyList
} from "../../../api/suitability";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;

export const myListConfig = {
    data() {
        return {
            myListType: '0',
            myListCompany: [],
            disableMyListCompany: false
        };
    },
    watch:{
        myListType:function (val) {
            let self = this;
            switch (val) {                
                case "1":
                    self.disableMyListCompany = false;
                break;
                default:
                    self.disableMyListCompany = true;
            }
        }
    },
    methods: {
        handleMyListData() {
            const self = this;
            self.myListSettingDialogVisible = true;
            
            self.dialogLoading = true;
            self.fillMyListConfigData();           
        },
        fillMyListConfigData() {
            const self = this;
            getInfo()
            .then((response) => {
                let result = response.data;
                if (result == undefined) {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                } else {
                    if (checkResponseStatus(result, self)) {
                        self.myListType = result.data.myListType
                        if(self.myListType == '1')
                        {
                            self.myListCompany = result.data.myListCompany;
                            self.disableMyListCompany = false;
                        }                        
                        else
                        {
                            self.disableMyListCompany = true;
                        }
                    }
                }
            })
            .catch((err) => {
                Message({
                    message: "数据异常，请尝试刷新再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
            })
            .finally((r) => {
                self.dialogLoading = false;
            });
        },
        saveConfigMyList() {
            const self = this;

            if(self.myListType =="" || self.myListType == null)
            {
                Message({
                    message: "保存失败：请选择[基金列表]！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
                return false;
            }

            if(self.myListType =="1" && (self.myListCompany =="" || self.myListCompany == null))
            {
                Message({
                    message: "保存失败：当[基金列表]选择[指定基金公司]，请[添加基金公司]到[基金公司列表]！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
                return false;
            }
            else{
                if(self.myListType !="1")
                {
                    self.myListCompany ="";
                }
            }
           
            self.myListSettingDialogVisible = false;
            self.dialogLoading = true;
            let params = {
                myListType : self.myListType,
                myListCompany : self.myListCompany
            };
            self.editMyListConfig(params);
        },
        editMyListConfig(params) {
            const self = this;
            editMyList(params)
            .then((response) => {
                let result = response.data;
                if (result == undefined) {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                } else {
                    if (checkResponseStatus(result, self)) {

                        let userInfo = JSON.parse(getNameAndValue("info"));                                            
                        userInfo.myListType = params.myListType;
                        userInfo.myListCompany = params.myListCompany;
                        setNameAndValue("info", userInfo);                             
                        
                        self.loadingData(); 

                        Message({
                            message: "保存成功",
                            type: "success",
                            duration: 2 * 1000,
                        });
                        Message.close = function() {};
                    }
                }
            })
            .catch((err) => {
                Message({
                    message: "数据异常，请尝试刷新再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
            })
            .finally((r) => {                
                self.dialogLoading = false;
            });
        },
        handleRemoveCompany(companyName) {
            const self = this;
            let index = self.myListCompany.indexOf(companyName);
            if (index != -1) self.myListCompany.splice(index, 1);

            self.$refs.scrollbarMyList.update();
            // console.log(this.disableMyListCompany);
        },
        handleAddCompany(companyName) {
            const self = this;
            if (companyName) {        
                if (self.myListCompany === null || self.myListCompany == "" || self.myListCompany == undefined) {
                    self.myListCompany = [];
                }
                self.myListCompany.push(companyName);
                self.companyName = "";
                self.$refs.scrollbarMyList.update();
            }
        }
    },
};
